import React, { useEffect, useState } from "react";
import FunnelGraph from "funnel-graph-js";
import "./funnel.scss";
import CustomLegend from "./customLegend";

const FunnelGraphComponent = ({ key, chartData, containerId }) => {
  const [colors, setColors] = useState([]);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    // Ensure 'labels' and 'data' are correctly formatted
    if (
      !chartData ||
      !Array.isArray(chartData.labels) ||
      !Array.isArray(chartData.data)
    ) {
      console.error(
        "Invalid chartData: 'labels' or 'data' is missing or not an array"
      );
      return;
    }

    // Ensure there is a color for every data point, fallback to black if not
    const generateRandomColor = () => {
      const randomColor = `#${Math.floor(Math.random() * 16777215).toString(
        16
      )}`;
      return randomColor;
    };

    const colors =
      chartData.colors.length >= chartData.data.length
        ? chartData.colors.slice(0, chartData.data.length)
        : [
            ...chartData.colors,
            ...new Array(chartData.data.length - chartData.colors.length)
              .fill(null)
              .map(generateRandomColor),
          ];
    setColors(colors);
    // Select the container element where the funnel graph will be rendered
    const containerSelector = `#${containerId}`;
    const containerElement = document.querySelector(containerSelector);

    if (containerElement) {
      containerElement.innerHTML = "";

      const containerWidth = containerElement.offsetWidth;
      const heightPerDataPoint = 90;
      const containerHeight = chartData.data.length * heightPerDataPoint;

      const combinedData = chartData.labels.map((label, index) => ({
        label: label,
        value: chartData.data[index],
        color: colors[index],
      }));

      combinedData.sort((a, b) => b.value - a.value);

      const graphData = {
        labels: combinedData.map((item) => item.label),
        values: combinedData.map((item) => item.value),
        subLabels: combinedData.map((item) => item.label),
        colors: combinedData.map((item) => item.color),
      };

      const graph = new FunnelGraph({
        container: containerSelector,
        gradientDirection: "horizontal",
        data: graphData,
        displayPercent: true,
        direction: "vertical",
        width: containerWidth,
        height: containerHeight,
        barSpacing: 10,
      });

      graph.draw();
      setIsVisible(true);
    }
  }, [chartData, containerId]); // Redraw on data or container change

  return (
    <div key={key} className="funnel-container">
      <div
        id={containerId}
        className={`funnel ${isVisible ? "visible" : ""}`}
      />
      <CustomLegend chartData={chartData} colors={colors} />
    </div>
  );
};

export default FunnelGraphComponent;
